export default "__VITE_ASSET__BXlFV7wU__"